module.exports = __webpack_public_path__ + "img/31_16.7b10b2c8.png";